<template>
    <div class="Cards">
		<div class="Cards__header">
			<h2>{{ $t('CardsHeader') }}</h2>
		</div>
		<div class="Cards__container">
			<Card 
				v-for="card in cardContent" 
				:key="card.id" 
				:imageURL="card.imageURL" 
				:cardTitle="card.cardTitle" 
				:cardDescription="card.cardDescription"
				:goToServiceHandler="goToService"
			/>
		</div>
        
    </div>
</template>

<script>
import Card from '@/components/Card'

export default {
    name: 'Cards',
    components: {
        Card
	},
	computed: {
		cardContent() {
			return [
                {
                    imageURL: 'autografika',
					cardTitle: this.$t('CardsTitleAutografika'),
					cardDescription: this.$t('SerivceDescriptionAutografika'),
                    id: 1
                },
                {
                    imageURL: 'forekspleksi',
					cardTitle: this.$t('CardsTitleForeksPleksi'),
					cardDescription: this.$t('SerivceDescriptionForeksPleksi'),
                    id: 2
                },
                {
                    imageURL: 'pvc',
					cardTitle: this.$t('CardsTitlePVC'),
					cardDescription: this.$t('SerivceDescriptionPVC'),
                    id: 3
                },
                {
                    imageURL: 'cerade',
					cardTitle: this.$t('CardsTitleCerade'),
					cardDescription: this.$t('ServiceDescriptionCerade'),
                    id: 4
                },
			]
		}
	},
	methods: {
		goToService(serviceID) {
			this.$router.push({ name: 'Services', params: { serviceID: serviceID } })
		}
	}
}
</script>

<style lang="scss" scoped>
.Cards {
	width: 100%;

	&__header {
		display: flex;
		justify-content: center;
		align-items: center;
		background: $blue;
		padding: 20px;

		h2 {
			margin: 0;
			color: white;
			font-weight: 400;

			@media screen and (min-width: 768px) {
				font-size: 2em;
			}
		}
	}

	&__container {
		width: 100%;
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: auto;
		grid-gap: 20px;
		justify-items: center;
		padding: 20px;
		
		@media screen and (min-width: 425px) {
			grid-template-columns: repeat(2, 1fr);
		}
		@media screen and (min-width: 768px) {
			grid-template-columns: repeat(4, 1fr);
		}
	}
}
</style>
